import type {
  ButtonBackground,
  ButtonColor,
  ButtonStyle,
} from '@tranquility-ai/theme-components/button';

/**
 * Shared chrome for the pulsing call-to-action on empty/landing states
 * (Timelines Tutorial, Getting Started Guide). The glow is not expressible as a
 * Button variant, so it lives here as one class rather than being re-typed at
 * each call site; per-screen type scale and padding stay at the call site.
 */
export const glowCtaButtonProps = {
  style: 'solid' as ButtonStyle,
  color: 'accent' as ButtonColor,
  background: 'inverse' as ButtonBackground,
};

export const GLOW_CTA_BUTTON_CLASS =
  'font-light animate-glow [box-shadow:0_0_8px_rgba(89,162,247,0.6),0_0_16px_rgba(89,162,247,0.4),0_0_24px_rgba(89,162,247,0.3)]';
